<div class="step-bar">
	<div class="container">
		<!--  BACK BUTTON (STEP)  -->

		<a
			*ngIf="show_back && back_url === null"
			class="back"
			data-element-click="back_button__engage_configure_step_bar__[Back]"
			(click)="goBack()"
		>
			<span class="text">Back</span>
			<i class="icon-arrow-left"></i>
		</a>

		<!--  END BACK BUTTON (STEP)  -->

		<!--  BACK BUTTON (URL)  -->

		<a
			*ngIf="show_back && back_url !== null"
			class="back"
			[href]="back_url"
			[attr.data-element-click]="'showroom_button__engage_configure_step_bar__[' + back_text + ']'"
		>
			<span class="text">{{ back_text }}</span>
			<i class="icon-arrow-left"></i>
		</a>

		<!--  BACK BUTTON (URL)  -->

		<!--  PAGINATION BULLETS  -->

		<div *ngIf="show_pagination" class="pagination hidden-xxs hidden-xs">
			<ul>
				<li
					*ngFor="let s of steps_order"
					[attr.data-element-click]="'step_bullet__engage_configure_step_bar__[' + steps[s].name + ']'"
					(click)="jumpTo(s)"
				>
					<span class="bullet" [class.active]="s === current_step_key"></span>
				</li>
			</ul>
		</div>

		<!--  END PAGINATION BULLETS  -->

		<!--  NEXT BUTTON  -->

		<a
			*ngIf="show_next"
			class="next pri-fg"
			[class.disabled]="next_disabled"
			[attr.data-element-click]="'next_button__engage_configure_step_bar__[' + next_text + ']'"
			(click)="goNext()"
		>
			<span class="backdrop pri-bg"></span>
			<span *ngIf="!next_submitting" class="text">{{ next_text }}</span>
			<i *ngIf="!next_submitting" [ngClass]="next_icon"></i>
			<div *ngIf="next_submitting" class="loading-spinner"></div>
		</a>

		<!--  END NEXT BUTTON  -->
	</div>
</div>
